export default __webpack_public_path__ + "static/media/banner-2.73c97e9d.jpg";